import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import Select from "react-select";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import classNames from "classnames";
import { getData } from "../../../utils/api";
import { ItemType, SelectImageData } from "../../../utils/common";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    control,
    setValue,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image"); // Track image input

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("item_type_id", ItemType.Product);

      // Use the image from gallery selection or file upload
      if (data?.image && data?.image[0]) {
        sendData.append("image", data?.image[0]);
      } else if (data?.gallery_image?.image) {
        sendData.append("image", data?.gallery_image?.image);
      }

      sendData.append("bg_color", data?.bg_color);
      sendData.append("btn_color", data?.btn_color);

      const response = await postData(`/admin/masters/p-category`, sendData);

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e?.target?.files[0] || e;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [GalleryImages, setGalleryImages] = useState([]);
  const getGalleyImages = async () => {
    try {
      const response = await getData("/common/masters/all-gallery-images");

      // Check if response and response.data exist
      if (response && response.data) {
        setGalleryImages(await SelectImageData(response.data, "image"));
      } else {
        console.error("No gallery images data found:", response);
      }
    } catch (error) {
      console.error("Error fetching gallery images:", error);
    }
  };

  useEffect(() => {
    getGalleyImages();
  }, []);

  const handleGalleryImageChange = (selectedOption) => {
    // Reset the file input when an image is selected from the gallery
    setValue("image", null); // Reset file input
    setValue("gallery_image", selectedOption); // Set the gallery image in the form
    setImagePreview(IMG_URL + selectedOption?.image); // Set the selected image preview
    clearErrors();
  };

  const handleFileInputChange = (e) => {
    // Reset the dropdown when a file is uploaded
    setValue("gallery_image", null); // Reset gallery selection
    handleImageChange(e); // Handle the file input change
    clearErrors();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Product Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label> Product Category</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Category"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Category Name is required",

                          validate: (value) =>
                            value?.trim() ? true : "Category name is required",

                          maxLength: {
                            value: 200,
                            message:
                              "Category name cannot exceed 200 characters",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Background Color</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="color"
                        {...register("bg_color", {
                          required: "Background color is required",
                        })}
                        className={classNames("form-control-color", {
                          "is-invalid": errors?.bg_color,
                        })}
                        style={{ width: "60px", height: "40px" }}
                      />
                    </InputGroup>

                    {errors.bg_color && (
                      <span className="text-danger">
                        {errors.bg_color.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Button Color</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="color"
                        {...register("btn_color", {
                          required: "Button color is required",
                        })}
                        className={classNames("form-control-color", {
                          "is-invalid": errors?.btn_color,
                        })}
                        style={{ width: "60px", height: "40px" }}
                      />
                    </InputGroup>

                    {errors.btn_color && (
                      <span className="text-danger">
                        {errors.btn_color.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="image"
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                          // validate: async (value) => {
                          //   console.log("value[0].name", value[0].name);

                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          //     const fileType = value[0].name?.split(".")[1];

                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (sizes.width !== 928 && sizes.height !== 945) {
                          //       return "Image width and height must be 928 px and 945 px";
                          //     }
                          //     const fileSize = Math.round(value[0].size / 1024);
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }

                          //     // if (!fileTypes.includes(fileType)) {
                          //     //   return `please upload a valid file format. (${fileTypes})`;
                          //     // }

                          //     // const sizes = await getDimension(value[0]);
                          //     // if (
                          //     //   sizes.width !== 200 &&
                          //     //   sizes.height !== 200
                          //     // ) {
                          //     //   return "Image width and height must be 200 px and 200 px";
                          //     // }

                          //     // const fileSize = Math.round(
                          //     //   value[0].size / 1024
                          //     // );
                          //     // if (fileSize > 500) {
                          //     //   return "file size must be lower than 500kb";
                          //     // }
                          //   }
                          // },
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Gallery Image</Form.Label>
                    </div>
                    <InputGroup>
                      <Controller
                        name="gallery_image" // name of the field
                        {...register("gallery_image", {
                          required: !getValues("image")
                            ? "Select Image"
                            : false,
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.gallery_image
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={GalleryImages} // Pass gallery images here
                            onChange={handleGalleryImageChange} // Handle gallery selection change
                            formatOptionLabel={(option) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={IMG_URL + option?.image}
                                  alt={option?.label}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    marginRight: "10px",
                                  }}
                                />
                                <span>{option?.label}</span>
                              </div>
                            )}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.gallery_image && (
                      <span className="text-danger">
                        {errors.gallery_image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  {imagePreview && (
                    <div className="image-preview-container">
                      <img
                        src={imagePreview} // Display the selected image preview
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
